import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useAuth } from "@/contexts/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";
import { LOGIN } from "@/constants/testIds";

const LOGIN_BG = "https://images.unsplash.com/photo-1778151270886-f227700b0eba?crop=entropy&cs=srgb&fm=jpg&q=85";

export default function LoginPage() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/dashboard");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex font-sans">
      <div className="w-full lg:w-1/2 flex items-center justify-center px-6 py-12 bg-background">
        <div className="w-full max-w-sm animate-in fade-in slide-in-from-bottom-4 duration-500">
          <h1 className="font-serif text-3xl tracking-[0.1em] text-brand mb-1">STRANI</h1>
          <p className="text-sm text-muted-foreground mb-8">Just Because &middot; Panel de gestión clínica</p>

          <h2 className="font-serif text-2xl sm:text-3xl tracking-tight text-foreground mb-6">Bienvenida de nuevo</h2>

          <form onSubmit={handleSubmit} className="space-y-4" data-testid="login-form">
            <div>
              <Label className="text-sm text-muted-foreground mb-1 block">Email</Label>
              <Input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="tu@clínica.com"
                data-testid={LOGIN.emailInput}
              />
            </div>
            <div>
              <Label className="text-sm text-muted-foreground mb-1 block">Contraseña</Label>
              <Input
                type="password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="********"
                data-testid={LOGIN.passwordInput}
              />
            </div>

            {error && (
              <div className="text-sm text-destructive bg-destructive/10 border border-destructive/20 rounded-lg px-3 py-2" data-testid="login-error-message">
                {error}
              </div>
            )}

            <Button type="submit" className="w-full bg-brand hover:bg-brand-hover text-white" disabled={loading} data-testid={LOGIN.submitButton}>
              {loading ? "Ingresando..." : "Ingresar"}
            </Button>
          </form>

          <p className="text-sm text-muted-foreground mt-6 text-center">
            Sos la dueña de la clínica y aun no tenes cuenta?{" "}
            <Link to="/register" className="text-brand hover:text-brand-hover font-medium" data-testid={LOGIN.registerLink}>
              Registra tu clínica
            </Link>
          </p>
        </div>
      </div>

      <div className="hidden lg:block lg:w-1/2 relative">
        <img src={LOGIN_BG} alt="Clínica Strani Just Because" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-white/20 backdrop-blur-[2px]" />
        <div className="absolute bottom-12 left-12 right-12 bg-white/80 backdrop-blur-sm rounded-xl p-6 border border-border">
          <p className="font-serif text-xl text-foreground">"Belleza, ciencia y cuidado en cada detalle."</p>
          <p className="text-sm text-muted-foreground mt-1">Strani Just Because &mdash; Houston, TX</p>
        </div>
      </div>
    </div>
  );
}
